module.exports = __webpack_public_path__ + "assets/img/Inter-ExtraBold.svg?5184261c9f01cc39409fcae82a543ebc";